import { render, staticRenderFns } from "./IndexApp.vue?vue&type=template&id=2ca0adea&"
import script from "./IndexApp.vue?vue&type=script&lang=js&"
export * from "./IndexApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports